import { NavLink } from 'react-router-dom';

function RefferedByMe({ refData = [], loading }) {
  return (
    <div className="ant-list-box table-responsive" style={{ maxHeight: 400 }}>
      <table className="width-100">
        <thead>
          <tr>
            <th>User ID</th>
          </tr>
        </thead>
        <tbody>
          {refData && refData.map((data) => {
            return (
              <tr>
                <td>
                  <NavLink to={`/user/${data.value}`}>
                    <span className="label" style={{ textDecoration: 'underline' }}>{data.value}</span>
                  </NavLink>
                  {/* <CustomText
                    dataSet={data}
                    property1={'value'}
                    isHyperLink={true}
                  /> */}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default RefferedByMe;
